// This import loads the firebase namespace along with all its type information.
import Title from './title-model'

export async function load_titles(): Promise<Title[]> {
  throw 'Not implemented'
}

export async function delete_title(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_title(): Promise<Title> {
  throw 'Not implemented'
}
